import { render, staticRenderFns } from "./input-item.vue?vue&type=template&id=5f97d414&"
import script from "./input-item.vue?vue&type=script&lang=js&"
export * from "./input-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports